import { Chip, Tooltip } from '@mui/material';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { ACTIVITY_TYPE_LABELS, ACTIVE_STATUS, handleValidateCodevalue, idWidth, LEAD_STATUS, LEAD_STATUS_PROSPECT, nameWidth, ownerWidth, sellingPriceWidth, statusWidth, templateSubjectWidth, whocolumnWidth } from '../../Utility/constant';
import { useSelector } from 'react-redux';
import history from '../../Utility/history';
import { privateRoutesPath } from '../../Routes';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import LoaderIcon from '../../Assets/images/loader.svg';
import { StyledDiv } from '../../Components/Styled';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useSnackbar } from 'notistack';
import NotificationDialog from '../../Components/NotificationDialog';
import { isPastDate } from '../../Utility/calculations';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import {
  useActionablesConfig,
  useActionablesData,
  ActionablesFilters,
  ActionablesTabs
} from '../../Components/Actionable';
import StatusChip from '../../Components/StatusChip';
import TruncatedTextCell from '../../Components/TruncatedTextCell';
import LeadScoreBar from '../../Components/LeadScoreBar';
import useNavigation from '../../Utility/hooks/useNavigation';
import './Dashboard.css';

const LeadActionables = ({ onRegisterRefetch, isActive = true }) => {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);

  const {
    ownerDropdown,
    selectedOwner,
    handleSelectOwner,
    isDropdownDisabled,
    isReady,
    ownerLabel,
    ownerlist,
    myTeam,
    internationalise
  } = useActionablesConfig({ type: 'lead' });

  const lookupData = useSelector(state => state?.lookup?.lookupData);

const leadStatusData = useMemo(() => {
  const base = lookupData?.find(item => item?.name === LEAD_STATUS)?.codes || [];
  return base
    .filter(item => item?.status === ACTIVE_STATUS)
    .sort((a, b) => a?.sequence - b?.sequence);
}, [lookupData]);

const prospectStatuses = useMemo(() => {
  return (
    leadStatusData
      ?.filter(item => item?.systemLookupCode?.name === LEAD_STATUS_PROSPECT)
      ?.map(item => item?.name) || []
  );
}, [leadStatusData]);


  const {
    actionables,
    todayTableData,
    nextDaysTableData,
    filters,
    handleMarkAsRead,
    handleMarkAsReadIfUnread,
    markAsReadApi,
    handleToggleProspects,
    handleToggleUnread,
    getRowClassName,
    refetch,
  } = useActionablesData({
    type: 'lead',
    selectedOwner,
    ownerlist,
    myTeam,
    prospectStatuses,
    isActive
  });

  const [dialogState, setDialogState] = useState({ isCalendarOpen: false, notifyBox: null });

  useEffect(() => {
    if (onRegisterRefetch && refetch) {
      onRegisterRefetch(refetch);
    }
  }, [onRegisterRefetch, refetch]);

  const handleOpenNotifyBox = useCallback((row) => {
    const Owner = ownerDropdown?.find(item => item?.id === row?.ownerId);
    setDialogState(prev => ({
      ...prev,
      notifyBox: {
        row: row,
        open: true,
        destinationId: row?.leadId,
        receiverId: Owner?.id,
        ownerName: Owner?.name
      }
    }));
  }, [ownerDropdown]);

  const handleCloseNotifyBox = useCallback(() => {
    setDialogState(prev => ({
      ...prev,
      notifyBox: { message: "", open: false, ownerName: "", required: false }
    }));
  }, []);
  const { openInNewTab } = useNavigation();

  const handleEditLead = useCallback((row) => {
    markAsReadApi({
      ...row,
      read: false
    });

      openInNewTab(
        `${privateRoutesPath?.EDIT_LEAD}/${row?.leadId}`
      );
  }, [openInNewTab,location.pathname, markAsReadApi]);

  const columns = useMemo(() => [
    {
      field: 'actions',
      type: 'actions',
      headerName: handleValidateCodevalue(internationalise, 'COMMON_ACTION'),
      minWidth: 100,
      getActions: (params) => {
        const isRead = params.row.read;
        return [
          <Tooltip title={handleValidateCodevalue(internationalise, isRead ? 'DB_MARK_AS_UNREAD' : 'DB_MARK_AS_READ')}>
            <GridActionsCellItem
              key="mark-read"
              icon={
                isRead ? (
                  <TaskAltIcon fontSize="small" className="secondary-color" />
                ) : (
                  <RadioButtonUncheckedIcon fontSize="small" className="secondary-color" />
                )
              }
              label={handleValidateCodevalue(internationalise, isRead ? 'DB_MARK_AS_UNREAD' : 'DB_MARK_AS_READ')}
              onClick={(e) => {
                e.stopPropagation();
                handleMarkAsRead(params.row);
              }}
              showInMenu={false}
            />
          </Tooltip>,
          <Tooltip title={handleValidateCodevalue(internationalise, 'NOTIFY_TOOLTIP_TITLE')}>
            <GridActionsCellItem
              key="notify"
              icon={<NotificationsOutlinedIcon fontSize="small" className="secondary-color" />}
              label={handleValidateCodevalue(internationalise, 'NOTIFY_TOOLTIP_TITLE')}
              onClick={(e) => {
                e.stopPropagation();
                handleOpenNotifyBox(params.row);
              }}
              showInMenu={false}
            />
          </Tooltip>
        ];
      }
    },
    {
      field: 'ownerId',
      headerName: handleValidateCodevalue(internationalise, 'LEAD_SEARCH_OWNER'),
      flex: 1,
      editable: true,
      minWidth: ownerWidth,
      valueGetter: ({ value }) => {
        const owner = ownerDropdown.find(c => c.id === value);
        return owner ? owner.name : '';
      }
    },
    {
      field: 'leadId',
      headerName: handleValidateCodevalue(internationalise, 'LEAD_SEARCH_LEAD_ID'),
      flex: 1,
      minWidth: idWidth,
      editable: false,
      renderCell: (params) => {
        const { value, row } = params;
        return (
          <span
            onClick={()=>handleEditLead(row)}
            className="actionable-table-clickable-id"
          >
            {value}
          </span>
        );
      }
    },
    {
      field: 'firstName',
      headerName: handleValidateCodevalue(internationalise, 'LEAD_SEARCH_FIRSTNAME'),
      flex: 1,
      minWidth: nameWidth,
      editable: false
    },
    {
      field: 'lastName',
      headerName: handleValidateCodevalue(internationalise, 'LEAD_SEARCH_LASTNAME'),
      flex: 1,
      minWidth: nameWidth,
      editable: false
    },
    ...(specificRolePermission?.isAimlManage ?
      [
    {
      field: 'leadScore',
      headerName: handleValidateCodevalue(internationalise, 'LP_AI_SCORE'),
      flex: 0,
      editable: false,
      width: 150,
      renderCell: (params) => <LeadScoreBar score={params.value} />,
    }]
    : []),
 
    {
      field: 'latestNote',
      headerName: handleValidateCodevalue(internationalise, 'LEAD_SEARCH_FU_NOTE'),
      flex: 1,
      editable: true,
      minWidth: templateSubjectWidth,
      renderCell: (params) => (
        <TruncatedTextCell
          text={params.value}
          dialogTitle="LEAD_SEARCH_FU_NOTE"
          stripHtml={true}
          activityType={params.row.activityType}
          recipients={params.row.recipients}
          createdAt={params.row.createdAt}
          callStatus={params.row.callStatus}
          callDuration={params.row.callDuration}
        />
      )
    },
       {
      field: 'activityType',
      headerName: handleValidateCodevalue(internationalise, 'COMMON_DETAILS') || 'Details',
      flex: 1,
      editable: false,
      minWidth:nameWidth,
      renderCell: (params) => {
        return <span>{params.row.activityType ? ACTIVITY_TYPE_LABELS[params.row.activityType] || params.row.activityType : 'Note'}</span>;
      }
    },
    {
      field: 'totalValue',
      headerName: handleValidateCodevalue(internationalise, 'LEAD_SEARCH_TOTAL_VALUE'),
      flex: 1,
      minWidth: sellingPriceWidth,
      editable: false
    },
    {
      field: 'nextFollowupDate',
      headerName: handleValidateCodevalue(internationalise, 'DB_COL_FU_DATE'),
      flex: 1,
      editable: true,
      minWidth: whocolumnWidth,
      renderCell: (params) => {
        return (
          <Chip
            onClick={()=>handleEditLead(params?.row)}
            variant='outlined'
            className={(isPastDate(params?.row?.nextFollowupDate) && params?.row?.read === false)
              ? 'secondary-bg-color'
              : ""
            }
            label={params?.row?.nextFollowupDate}
          />
        );
      }
    },
    {
      field: 'leadStatus',
      headerName: handleValidateCodevalue(internationalise, 'LEAD_SEARCH_STATUS'),
      flex: 1,
      editable: false,
      minWidth: statusWidth,
      renderCell: (params) => (
        <StatusChip
          isLead = {true}
          systemLookup = {params?.row?.systemLookUpCodeStatus}
          status={params.row.leadStatus}
          internationalise={internationalise}                                                                                                                 
        />)

      // valueGetter: ({ value }) => {
      //   if (!value) return "";
      //   return handleValidateCodevalue(internationalise, value);
      // }
    }
  ], [internationalise, ownerDropdown, handleEditLead, handleMarkAsRead, handleOpenNotifyBox]);
const renderValuesOnCard = [
      { field: "leadStatus" , useLabel : true,left : true,useChip:true},
      { field: "nextFollowupDate" ,right : true},
      {
        field: "fullName",
        left : "true",
        combineFields: ["firstName", "lastName"]
      },
      { field: "totalValue" ,right : true,type : "currency"},
    ];

  return (
    <StyledDiv>
      <ActionablesFilters
        internationalise={internationalise}
        ownerDropdown={ownerDropdown}
        selectedOwner={selectedOwner}
        onOwnerChange={handleSelectOwner}
        isDropdownDisabled={isDropdownDisabled}
        ownerLabel={ownerLabel}
        filters={filters}
        onToggleUnread={handleToggleUnread}
        onToggleProspects={handleToggleProspects}
        showProspectToggle={true}
        isCalendarOpen={dialogState.isCalendarOpen}
        onOpenCalendar={() => setDialogState(prev => ({ ...prev, isCalendarOpen: true }))}
      />

      <ActionablesTabs
        handleMarkAsRead = {handleMarkAsRead}
        titleField = "leadId"
        handleOnClickCard = {handleEditLead}
        renderValuesOnCard = {renderValuesOnCard}
        internationalise={internationalise}
        columns={columns}
        todayData={todayTableData}
        nextDaysData={nextDaysTableData}
        allData={actionables}
        getRowClassName={getRowClassName}
        isCalendarOpen={dialogState.isCalendarOpen}
        onCloseCalendar={() => setDialogState(prev => ({ ...prev, isCalendarOpen: false }))}
      />

      {dialogState.notifyBox?.open && (
        <NotificationDialog
          open={dialogState.notifyBox.open}
          ownerName={dialogState.notifyBox.ownerName}
          destinationType="LEAD"
          contextPayload={{
            destinationId: dialogState.notifyBox.destinationId,
            receiverId: dialogState.notifyBox.receiverId
          }}
          handleMarkAsReadIfUnread={() => handleMarkAsReadIfUnread(dialogState.notifyBox?.row)}
          onClose={handleCloseNotifyBox}
          enqueueSnackbar={enqueueSnackbar}
          internationalise={internationalise}
          handleValidateCodevalue={handleValidateCodevalue}
        />
      )}
    </StyledDiv>
  );
};

export default LeadActionables;
